import Vue from 'vue';
import { store } from './store/index.js';
import { router } from './router/index.js';
import App from './App';
import VueModal from '@/component/modal/VueModal.vue';
import { Modal } from '@/component/modal/LemonhcModal.js';
import RadioListItem from '@/component/RadioListItem.js';
import VueToast from 'vue-toast-notification';

window.Lemonhc = {
    component: {
        modal: Modal,
    },
};

await import('mf_style/plugins_insu').catch(e => console.log(e));
await import('mf_style/reset').catch(e => console.log(e));
await import('mf_style/style_renewal').catch(e => console.log(e));
await import('mf_style/icon-fonts').catch(e => console.log(e));

Vue.use(VueToast);
Vue.component('VueModal', VueModal);
Vue.component('RadioListItem', RadioListItem);

Vue.config.devtools = true;
window.EventBus = new Vue();

new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App),
    created: function() {
        window.modalStack = [];
    },
});
